'use strict';

var moment = require('moment');
var _ = require('lodash');
var FlightDOWAggregationFactory = function FlightDOWAggregationFactory(FlightThematicDataAggregationFactory) {
  var DOW = moment.weekdaysShort();
  function FlightDOWAggregation() {
    FlightThematicDataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-dow');
    this.aggregationProperty = 'departureDateDOW';
  }
  FlightDOWAggregation.prototype = Object.create(FlightThematicDataAggregationFactory.prototype);
  FlightDOWAggregation.constructor = FlightDOWAggregation;
  FlightDOWAggregation.prototype.sortAggregationResults = function (data) {
    data = _.map(data);
    data.sort(function (a, b) {
      return DOW.indexOf(a.label) - DOW.indexOf(b.label);
    });
    return data;
  };
  return FlightDOWAggregation;
};
FlightDOWAggregationFactory.$inject = ['FlightThematicDataAggregationFactory'];
module.exports = FlightDOWAggregationFactory;